import {AxiosResponse} from "axios";
import axios from "../utils/axios";
import {QuestionQuery} from "../models/Question";

export const fetchQuestions = (token: string) => {
  return new Promise<AxiosResponse<QuestionQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/questions/?limit=999`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.results);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}